import SectionHeader from '@/components/base/SectionHeader';

const REVIEWS = [
  {
    quote:
      '以前追一个瓜要在七八个地方翻来翻去，现在一条时间线看下来，谁先发的声明、什么时候反转，全清楚了。',
    name: '阿柚',
    role: '资深吃瓜群众',
    initial: '柚',
  },
  {
    quote:
      '最舒服的是有进度条和结局标记。有的瓜看一半就忘了，这里能直接看到演到哪一幕，省心。',
    name: '大鹏',
    role: '通勤路上追瓜',
    initial: '鹏',
  },
  {
    quote:
      '反转节点标得很清楚，不会把旧消息当新消息。看完全程再下判断，比刷短视频靠谱多了。',
    name: 'Lisa',
    role: '内容观察爱好者',
    initial: 'L',
  },
];

const PRINCIPLES = [
  { icon: 'ri-time-line', title: '只按时间线说事', desc: '每个节点都带日期，先后顺序不颠倒' },
  { icon: 'ri-scales-3-line', title: '多方说法都列上', desc: '不替任何一方下结论，把说法摆出来' },
  { icon: 'ri-refresh-line', title: '有进展就更新', desc: '反转与续集会重新点亮这条时间线' },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          eyebrow="口碑与原则"
          title="大家为什么愿意在这里追瓜"
          description="把信息排清楚，比抢先爆料更重要。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {REVIEWS.map((review) => (
            <figure
              key={review.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {review.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
                  {review.initial}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{review.name}</span>
                  <span className="block text-xs text-foreground-500">{review.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {PRINCIPLES.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 rounded-lg bg-background-50 p-5"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}